<template>
  <div class="mt-4">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="text-muted text-sm">
        Показано {{ start }}–{{ end }} из {{ totalCount }}
      </div>
      <div class="d-flex align-items-center">
        <span class="text-muted mr-2">Записей на странице:</span>
        <b-form-select
          v-model="localLimit"
          :options="limitOptions"
          size="sm"
          style="width: 80px"
          @change="limitChanged"
        />
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <b-pagination
        v-model="localPage"
        :per-page="localLimit"
        :total-rows="totalCount"
        size="sm"
        @change="pageChanged"
      />
    </div>
  </div>
</template>

<script>
import { BPagination, BFormSelect } from 'bootstrap-vue'

export default {
  name: 'PaginationControls',
  components: { BPagination, BFormSelect },
  props: {
    page: Number,
    limit: Number,
    totalCount: Number,
    limitOptions: Array,
  },
  data() {
    return {
      localPage: this.page || 1,
      localLimit: this.limit || 10,
    }
  },
  computed: {
    start() {
      return (this.localPage - 1) * this.localLimit + 1
    },
    end() {
      return Math.min(this.localPage * this.localLimit, this.totalCount)
    },
  },
  methods: {
    pageChanged(val) {
      this.$emit('page-change', val)
    },
    limitChanged(val) {
      this.$emit('limit-change', val)
    },
  },
}
</script>
